var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsTip = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _dsWeb = require("@olxbr/ds-web");
var _lurker = require("../../../helpers/lurker");
var _ = require("../");
var _jsxRuntime = require("react/jsx-runtime");
var _this = this,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/RateTip/StepsTip/index.js";
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StepsTip = function StepsTip(_ref) {
  var chatId = _ref.chatId,
    accountId = _ref.accountId,
    securityStorage = _ref.securityStorage,
    fastResponseStorage = _ref.fastResponseStorage,
    partnerName = _ref.partnerName;
  var _useState = (0, _react.useState)(securityStorage),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    securityRating = _useState2[0],
    setSecurityRating = _useState2[1];
  var _useState3 = (0, _react.useState)(fastResponseStorage),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    fastResponseRating = _useState4[0],
    setFastResponseRating = _useState4[1];
  var onChangeSecurityRating = function onChangeSecurityRating(rating) {
    setSecurityRating(rating);
    sendRatings('security', rating);
    (0, _.setRatingStorage)({
      rating: rating,
      fastResponseRating: fastResponseRating,
      chatId: chatId,
      accountId: accountId
    });
  };
  var onChangeFastResponseRating = function onChangeFastResponseRating(rating) {
    setFastResponseRating(rating);
    sendRatings('fast_response', rating);
    (0, _.setRatingStorage)({
      securityRating: securityRating,
      rating: rating,
      chatId: chatId,
      accountId: accountId
    });
  };
  var sendRatings = function sendRatings(question, rating) {
    (0, _lurker.clickSendRating)({
      rating: rating,
      question: question,
      chat_id: chatId,
      accountId: accountId
    });
  };
  var getSecondTip = function getSecondTip(rating) {
    if (rating) {
      return (0, _jsxRuntime.jsx)(_dsWeb.Flex, {
        marginTop: "--spacing-2",
        children: (0, _jsxRuntime.jsx)(_dsWeb.Alertbox, {
          title: "Quanto voc\xEA se sentiu seguro ao negociar com ".concat(partnerName, "?"),
          icon: (0, _jsxRuntime.jsx)(_dsIcons.TrustShield, {}),
          children: (0, _jsxRuntime.jsx)(_.RatingComponent, {
            disabled: securityRating,
            initialValue: securityRating,
            onChange: onChangeSecurityRating
          })
        })
      });
    }
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  };
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [getSecondTip(fastResponseRating), (0, _jsxRuntime.jsx)(_dsWeb.Flex, {
      marginTop: "--spacing-2",
      children: (0, _jsxRuntime.jsx)(_dsWeb.Alertbox, {
        title: "As informa\xE7\xF5es passadas por ".concat(partnerName, " foram \xFAteis?"),
        icon: (0, _jsxRuntime.jsx)(_dsIcons.ThumbsUp, {}),
        children: (0, _jsxRuntime.jsx)(_.RatingComponent, {
          disabled: fastResponseRating,
          initialValue: fastResponseRating,
          onChange: onChangeFastResponseRating
        })
      })
    })]
  });
};
exports.StepsTip = StepsTip;